import getApplicationEnvironment from "@/utils/getApplicationEnvironment";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import { OWN_ORIGIN } from "@/base/base.constants";

const { isProductionEnv, isStagingEnv, isDevEnv, isFeatureEnv } =
  getApplicationEnvironment();

const API_HOSTS = {
  DEV: "https://app.dev.newseladev.com",
  STAGING: "https://app.staging.newseladev.com",
  PROD: "https://app.newsela.com",
} as const;

// TEMPORARY Phase I fallback: Set to true to revert API_BASE_URL to MONOLITH_ORIGIN for feature envs
// This allows feature environments to use their own backend API when needed (e.g., during onboarding flows
// that involve the Monolith Frontend, which authenticates users against the feature env's own backend).
// This flag will be replaced with a proper environment variable in Phase II.
const USE_FEATURE_ENV_API = true;

export const API_BASE_URL = (() => {
  const lifecycle = process?.env?.["npm_lifecycle_event"];

  const isLocalHost = OWN_ORIGIN.includes("localhost");
  if (isLocalHost) {
    switch (lifecycle) {
      case "dev":
        return MONOLITH_ORIGIN;
      case "dev:no-local-monolith-check":
        return API_HOSTS.DEV;
      default:
        return MONOLITH_ORIGIN;
    }
  }

  if (isProductionEnv) return API_HOSTS.PROD;
  if (isStagingEnv) return API_HOSTS.STAGING;
  if (isDevEnv) return API_HOSTS.DEV;
  if (isFeatureEnv) {
    return USE_FEATURE_ENV_API ? MONOLITH_ORIGIN : API_HOSTS.DEV;
  }
  return API_HOSTS.DEV;
})();

export const DEFAULT_API_TIMEOUT = 1_000 * 60 * 5;

export const DEFAULT_HEADERS = {
  "Content-Type": "application/json",
};

export const GLOBAL_REQUEST_INTERCEPTORS = [];

export const GLOBAL_RESPONSE_INTERCEPTORS = [];
